import { useState, useEffect } from "react";
import api from "../utils/apiConfig";

export default function useClientDatabase() {
  const [households, setHouseholds] = useState([]);
  const [accounts, setAccounts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [totalCount, setTotalCount] = useState(0);

  useEffect(() => {
    let isMounted = true;
    setLoading(true);
    // Fetch first page
    api
      .get(
        "/advisor-portal/client-database/households-with-accounts?include_contact=true&include_risk=true&limit=10&offset=0",
      )
      .then((res) => {
        if (!isMounted) return;
        const householdsArr = res.data.households || [];
        setHouseholds(householdsArr);
        setTotalCount(res.data.totalCount || householdsArr.length);
        setAccounts(
          householdsArr.flatMap((hh) =>
            (hh.accounts || []).map((acc) => ({
              ...acc,
              householdId: hh.householdId,
              householdName: hh.householdName,
            })),
          ),
        );
        setLoading(false);
        // Prefetch the rest in the background
        if ((res.data.totalCount || 0) > 10) {
          api
            .get(
              `/advisor-portal/client-database/households-with-accounts?include_contact=true&include_risk=true&limit=${res.data.totalCount}&offset=0`,
            )
            .then((res2) => {
              if (!isMounted) return;
              const allHouseholds = res2.data.households || [];
              setHouseholds(allHouseholds);
              setAccounts(
                allHouseholds.flatMap((hh) =>
                  (hh.accounts || []).map((acc) => ({
                    ...acc,
                    householdId: hh.householdId,
                    householdName: hh.householdName,
                  })),
                ),
              );
            });
        }
      })
      .catch((err) => {
        if (isMounted) {
          setError(err.message || "Failed to fetch client database");
          setLoading(false);
        }
      });
    return () => {
      isMounted = false;
    };
  }, []);

  return { households, accounts, loading, error, totalCount };
}
